<div class="tw-bg-primary tw-text-white tw-rounded tw-p-4 tw-mb-4">
  <p class="tw-text-xl tw-font-bold tw-mb-2">Online Netsheet Calculator</p>
  <p class="tw-text-base">Calculate an estimated closing statement by filling in the fields below.</p>
</div>

<nsc-netsheet-calculator (export)="onExport($event)"></nsc-netsheet-calculator>
